import { frontendURL } from '../../../helper/URLHelper';
import KanbanView from './KanbanView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_board',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: KanbanView,
  },
  {
    // Painel aberto: URL carrega o id da conversa — os scripts injetados
    // (interart-vendas etc.) detectam a conversa pela URL e injetam os cards
    // de vendas/artes também dentro do kanban. Back do navegador fecha o painel.
    path: frontendURL(
      'accounts/:accountId/kanban/conversations/:conversation_id'
    ),
    name: 'kanban_board_conversation',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: KanbanView,
  },
];
